import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useProjectConsult = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [projectList, setProjectList] = useState<ProjectListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.project.consult.list, location.search],
    () =>
      fetcher.project.postProjectConsultList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        biz: searchParams.biz ? String(searchParams.biz) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '',  
        target: searchParams.target ? String(searchParams.target) : '',  
        lecture_type: searchParams.lecture_type ? String(searchParams.lecture_type) : '',  
        lecture_subject: searchParams.lecture_subject ? String(searchParams.lecture_subject) : '',  
        step: searchParams.step ? String(searchParams.step) : '',  
        company: searchParams.company ? String(searchParams.company) : '', 
        order: searchParams.order ? String(searchParams.order) : '',
        reverse: searchParams.reverse ? String(searchParams.reverse) : '',   
        viewOnly: searchParams.viewOnly ? String(searchParams.viewOnly) : '', 
        group_id: searchParams.group_id ? Number(searchParams.group_id) : null,    
      }),
    {
      onSuccess: (res: ProjectListResDto) => {
        switch (res.code) {
          case 200:
            setProjectList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { projectList, searchResult, refetch };
};

export default useProjectConsult;
